import axios from "axios";
import { API_BASE_URL } from "../config";

const axiosAdminInstance = axios.create({
    baseURL: API_BASE_URL,
});

let isRefreshing = false;
let refreshSubscribers: ((token: string) => void)[] = [];

const subscribeTokenRefresh = (cb: (token: string) => void) => {
    refreshSubscribers.push(cb);
};

const onRefreshed = (token: string) => {
    refreshSubscribers.forEach((cb) => cb(token));
    refreshSubscribers = [];
};
axiosAdminInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("admin_access_token");
        if (token && config.headers) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);
axiosAdminInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        if (
            error.response?.status === 401 &&
            !originalRequest._retry &&
            !originalRequest.headers["X-Skip-Auth"]
        ) {
            originalRequest._retry = true;

            if (!isRefreshing) {
                isRefreshing = true;
                try {
                    const refreshToken = localStorage.getItem("admin_refresh_token");
                    const res = await axios.post<{ access_token: string }>(
                        `${API_BASE_URL}/admin/refresh`,
                        { refresh_token: refreshToken }
                    );

                    const newAccessToken = res.data.access_token;
                    localStorage.setItem("admin_access_token", newAccessToken);
                    isRefreshing = false;
                    onRefreshed(newAccessToken);
                } catch (err) {
                    isRefreshing = false;
                    window.location.href = "/admin/login";
                    return Promise.reject(err);
                }
            }

            return new Promise((resolve) => {
                subscribeTokenRefresh((token: string) => {
                    originalRequest.headers.Authorization = `Bearer ${token}`;
                    resolve(axiosAdminInstance(originalRequest));
                });
            });
        }

        return Promise.reject(error);
    }
);

export default axiosAdminInstance;
